import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { keyIn } from 'utils/immutable';

import AccountDropDown from './AccountDropDown';
import LanguageDropDown from './LanguageDropDown';
import Message from './Message';
import Notifications from './Notifications';
import SignInDropDown from './SignInDropDown';
import SupportDropDown from './SupportDropDown';

function SiteHeader(props) {
    let liveMapLogo = null;
    if (props.liveMapPage) {
        if (props.gateway) {
            liveMapLogo = (
                <h3 className="gatewayLiveMapLogo left" style={{ padding: '7px 0 0 10px' }}>
                    {props.siteName}
                </h3>
            );
        } else {
            liveMapLogo = (
                <div id="logo">
                    <img
                        style={{ height: '30px' }}
                        src={`${props.staticUrl}img/dataBasinLogo-trans.png`}
                        alt="Data Basin"
                    />
                </div>
            );
        }
    }

    let userMenu = [];
    if (props.userId) {
        userMenu = [
            <div key="account" className="right" style={{ marginLeft: 24 }}>
                <AccountDropDown />
            </div>,
            <Notifications key="notifications" />,
            <Message key="message" />
        ];
    } else {
        userMenu = [
            <SignInDropDown key="signIn" />,
            <div key="signUp" className="right">
                <a style={{ paddingRight: 6 }} href={Util.reverseURL('dbauth:create_account')}>
                    {pgettext('Sign up for an account', 'Sign Up')}
                </a>
            </div>
        ];
    }

    return (
        <div>
            <a href="/">
                {liveMapLogo}
            </a>

            <div id="SiteHeaderMenu" className="right">
                <LanguageDropDown />
                <SupportDropDown gateway={props.gateway} />
                {userMenu}
            </div>

            <div style={{ display: 'none' }}>
                /* Duplicated from above to ensure capture in djangojs.po */
                {pgettext('Sign up for an account', 'Sign Up')}
            </div>

            <div className="clear" />
        </div>
    );
}

SiteHeader.propTypes = {
    siteName: PropTypes.string.isRequired,
    staticUrl: PropTypes.string.isRequired,
    gateway: PropTypes.string,
    liveMapPage: PropTypes.bool.isRequired,
    userId: PropTypes.string
};

SiteHeader.defaultProps = {
    gateway: null,
    userId: null
};

const mapStateToProps = state => Object.assign(
    { userId: state.getIn(['people', 'userId']) },
    state.get('site').filter(keyIn('siteName', 'staticUrl', 'gateway', 'liveMapPage')).toJS()
);

export default connect(mapStateToProps)(SiteHeader);



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/index.jsx